<template>
  <div v-if="type == 'coupon'" class="c-coupon__top image-fit js-keep-ratio" data-ratio="0.75" v-on:click="clickModal? clickModal : null">
    <img v-if="img" v-lazy="getImgSrc(img[0])" alt=""/>
    <img v-else loading="lazy" src="/assets/images/aeontown-noimg.png" alt=""/>
  </div>
  <div v-else-if="type == 'campaign'" class="c-campaign-list__img image-fit js-keep-ratio" data-ratio="0.746">
    <img v-if="img" v-lazy="getImgSrc(img[0])" alt=""/>
    <img v-else loading="lazy" src="/assets/images/aeontown-noimg.png" alt=""/>
  </div>
  <div v-else></div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { Tenant } from "../../plugin/mixin.js";

export default Vue.extend({
  name: 'viewImage',
  props: [ 'type', 'img', 'clickModal'],
   mixins: [Tenant],
  components: {
  },
  async created() {
  },
  data() {
    return {
    }
  },
  computed: {
  }
})
</script>